import React from 'react';

export const TeamworkGraphIcon = (): React.JSX.Element => (
	<svg
		width={16}
		height={16}
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path d="M15 15L33 33" stroke="#8590A2" strokeWidth="7" strokeLinecap="round" />
		<circle cx="12" cy="12" r="10" fill="#0C66E4" />
		<circle cx="36" cy="12" r="10" fill="#82B536" />
		<circle cx="12" cy="36" r="10" fill="#8F45E8" />
		<circle cx="36" cy="36" r="10" fill="#FCA700" />
		<circle cx="12" cy="12" r="3.5" fill="#101214" />
		<circle cx="36" cy="12" r="3.5" fill="#101214" />
		<circle cx="12" cy="36" r="3.5" fill="#101214" />
		<circle cx="36" cy="36" r="3.5" fill="#101214" />
	</svg>
);
